<template>
  <nav>
    <ul
      data-bind="foreach: items"
      class="nav flex-column"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        class="nav-item"
      >
        <a
          href="#"
          class="nav-link"
          :class="{ 'child': item.isChild, 'active': item.name === model }"
          :data-name="item.name"
          :data-test="item.name"
          @click.prevent="onMenuItemClicked(item.name)"
        >
          <span>{{ item.text }}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
  import VerticalTabMenuItem from '@/VueComponents/VerticalTabMenu/Models/verticalTabMenuItem';

  const props = defineProps<{
    items: VerticalTabMenuItem[]
  }>();

  const model = defineModel({ type: String });

  if (!model.value) {
    model.value = props.items[0]?.name;
  }

  function onMenuItemClicked(itemName: string) {
    model.value = itemName;
  }
</script>
